import { combineReducers } from 'redux'

import info from './info.js'
import report from './report.js'
import personApprovalForm from './personApprovalForm.js'

export default combineReducers({ info, report, personApprovalForm })



// WEBPACK FOOTER //
// ./src/store/reducers/profile/index.js